import { Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { errorCatch, GET, useUserContext } from 'fennec-ui';
import { isAnyFederationAdministrator, isMyEvent } from '../../../common/Tool';
import AvatarAdmin from '../../components/AvatarAdmin';
import { EventContext } from '../../../common/Context';
import PageLayout from '../../components/PageLayout';

export default function CommonEventsByIDAvatarTemplate(props) {
    let { id } = useParams();
    const { auth } = props;
    const user = useUserContext();

    const [event, setEvent] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/meropriyatiya/admin/${id}`,
            ({ data }) => {
                setEvent(data);
            }, errorCatch);
    }, [])
    const admin = (event && user) ? (isMyEvent(event, user, false) || isAnyFederationAdministrator(user)) : false;
    return (
        <PageLayout hideBreadcrumbs={true}>
            <Row gutter={[5, 5]}>
                <Col span={24} style={{ paddingLeft: "1px", paddingRight: "2px" }}>
                    <Card size="small">
                        <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                            <div style={{ textAlign: "left" }}>
                                {(event && admin) &&
                                    <EventContext.Provider value={[event, setEvent]}>
                                        <AvatarAdmin />
                                    </EventContext.Provider>
                                }
                                {(event && !admin) && <>
                                    Нет прав на мероприятие
                                </>}
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
